import React, { useState } from "react";
import { MDXProvider } from "@mdx-js/react";
import { motion, useScroll, useSpring } from "framer-motion";

import mdxComponents from "../CustomComponents"; // Import all in one
import {
  MainContainer,
  DocumentationParagrah,
} from "../../pages/styles/sharedStyles"; // Import shared styles
import Title from "../../components/title/Title";
import DessertsProteinesMarkdown from "../markdown/nutrition/DessertsProteines.mdx";

const DessertsProteines = () => {
  const { scrollYProgress } = useScroll();
  const [scrollDirection, setScrollDirection] = useState("down");
  const [progress, setProgress] = useState(50); // Example initial value

  const mdxComponents = {
    ProgressBar: (props) => (
      <mdxComponents.ProgressBar progress={progress} {...props} />
    ), // Pass progress
  };

  const scaleX = useSpring(scrollYProgress, {
    stiffness: 100,
    damping: 30,
    restDelta: 0.001,
  });

  return (
    <MainContainer>
      <motion.div
        id="scroll-indicator"
        style={{
          width: "100vw", // Ensure full viewport width
          height: "10px", // Thickness of the bar
          backgroundColor: "#1f4788", // Bar color
          position: "fixed",
          top: 50,
          left: 0,
          transformOrigin: "0%",
          scaleX: scrollYProgress, // Animate width as you scroll
        }}
      />
      <Title
        title="Exemples de desserts protéinés"
        summary="Voici quelques exemples"
      />
      <DocumentationParagrah>
        <MDXProvider components={mdxComponents}>
          <DessertsProteinesMarkdown />
        </MDXProvider>
      </DocumentationParagrah>
    </MainContainer>
  );
};

export default DessertsProteines;
